import { useImmer } from "use-immer";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ASelectWithOptions } from "src/components/ASelect";
import axiosInstance from "src/utils/axios";
import useAuth from "src/hooks/useAuth";

export default function ProfileFormDialog({
  open,
  handleClose,
  currentProfile,
}) {
  const [profile, setProfile] = useImmer(currentProfile || {});
  const { getProfiles } = useAuth();

  const handleSubmit = async (event) => {
    event.preventDefault();
    // if (profile.id === undefined) {
    const response = await axiosInstance.post("/watchprofile", profile);
    if (response.data.status) {
      await getProfiles();
      handleClose();
    }
    // }
  };

  const handleDelete = async () => {
    const response = await axiosInstance.delete(`/watchprofile/${profile.id}`);
    if (response.data.status) {
      await getProfiles();
      handleClose();
    }
  };

  const handleChange = (value, fieldKey) => {
    setProfile((draft) => {
      draft[fieldKey] = value;
    });
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "5px",
        },
      }}
    >
      <DialogTitle>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "text.primary",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ minHeight: 300, paddingTop: "24px !important" }}>
        <Stack spacing={1} component="form" onSubmit={handleSubmit}>
          <TextField
            required
            autoFocus
            variant="outlined"
            value={profile.name || ""}
            placeholder="Name"
            onChange={(event) => handleChange(event.target.value, "name")}
          />
          <ASelectWithOptions
            required
            by="lang"
            placeholder="Select Display Language"
            value={profile.uiLang ? profile.uiLang : ""}
            handleSelect={(v) => handleChange(v, "uiLang")}
          />
          <ASelectWithOptions
            required
            by="lang"
            placeholder="Select Subtitle Language"
            value={profile.ccLang ? profile.ccLang : ""}
            handleSelect={(v) => handleChange(v, "ccLang")}
          />
          <ASelectWithOptions
            required
            by="lang"
            placeholder="Select Audio Language"
            value={profile.audioLang ? profile.audioLang : ""}
            handleSelect={(v) => handleChange(v, "audioLang")}
          />
          <TextField
            required
            type="number"
            variant="outlined"
            placeholder="Age"
            value={profile.age}
            onChange={(event) => handleChange(event.target.value, "age")}
          />
          <FormControlLabel
            value="top"
            control={<Switch color="primary" />}
            label="For Kids"
            // labelPlacement="top"
            checked={Boolean(profile.forkids)}
            onChange={(event) =>
              handleChange(event.target.checked ? 1 : 0, "forkids")
            }
          />
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button variant="contained" color="primary" type="submit">
              Save
            </Button>
            {profile.id && (
              <Button variant="contained" color="error" onClick={handleDelete}>
                Delete
              </Button>
            )}
            <Button variant="contained" color="inherit" onClick={handleClose}>
              Cancel
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
